import React, { useEffect, useRef, useState } from "react";
import { Dialog, DialogContent, Typography, Box, styled } from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import emailSend from "../assets/email_sent.webp";
import dashboardBg from "../assets/dashboardbg.png";
import { backend_api } from "../static/server";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: theme.spacing(2),
    padding: theme.spacing(5),
    maxWidth: 700,
    width: "100%",
    textAlign: "center",
  },
}));

const TrialSuccessPopUp = () => {
  const { email } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const hasCalled = useRef(false);

  useEffect(() => {
    if (!email || hasCalled.current) return;

    hasCalled.current = true;

    const sendEmail = async () => {
      try {
        setIsLoading(true);

        const response = await axios.get(
          `${backend_api}user/forget-password/?send_reset_link&email=${email}`,
        );

        // toast.success(response?.data?.message || "Reset link sent!");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to send email");
      } finally {
        setIsLoading(false);
      }
    };

    sendEmail();
  }, [email]);

  return (
    <Box
      sx={{
        backgroundImage: `url(${dashboardBg})`,
        backgroundSize: "cover",
        width: "100%",
        height: "100vh",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
      }}
    >
      <StyledDialog open={true} disableEscapeKeyDown>
        <DialogContent>
          <Box
            component="img"
            src={emailSend}
            alt="Email sent"
            sx={{
              width: "100%",
              maxHeight: 180,
              objectFit: "contain",
              mb: 4,
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = require("../assets/no-preview.webp");
            }}
          />
          <Typography variant="h4" fontWeight={600} gutterBottom>
            Check your email to activate your account
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mt: 2, fontSize: "1.1rem" }}
          >
            If you didn’t receive an email, check your junk or spam folder
            <br />
            or call <strong>xxxxxx-9090</strong>
          </Typography>
          {isLoading && (
            <Typography variant="body2" color="primary" sx={{ mt: 2 }}>
              Sending email...
            </Typography>
          )}
        </DialogContent>
      </StyledDialog>
    </Box>
  );
};

export default TrialSuccessPopUp;
